import * as D from '../clients/mira/types/Device';

// A device matches by its name, its owner's profile name, the start of its
// id, or any part of its serial number. The id prefix is what a screen shows
// support to read back: a Signage Stick's pairing screen shows the first 8
// characters of its id, and a Balena box shows its id (its MAC address) in
// full. The serial is what a person reads off a Stick's screen or label, so
// any part of it matches; a device with no serial matches by the rest.
export default function searchDevices(
  devices: D.Device[],
  searchQuery: string,
) {
  const searchQueryInsenstive = searchQuery.toLowerCase().trim();
  return devices.filter(
    (device) =>
      device.name.toLowerCase().includes(searchQueryInsenstive) ||
      device.resource.profile.name
        .toLowerCase()
        .includes(searchQueryInsenstive) ||
      device.id.toLowerCase().startsWith(searchQueryInsenstive) ||
      (device.serialNumber ?? '').toLowerCase().includes(searchQueryInsenstive),
  );
}
